<template>
  <div class="validate-document__container">
    <GenericCard>
      <div class="validate-document__card">
        <ValidateDocumentForm
          :subtitle-form="subtitleForm"
          :loading="loading"
          @onSearch="searchDocument"
        />
        <NonCustomerRecordModal
          ref="nonCustomerRecord"
          :loading="loadingModal"
          :fathers-name-required="requireLastName"
          :mothers-name-required="requireLastName"
          @onRegisterCustomer="registerCustomer"
        />
      </div>
    </GenericCard>
  </div>
</template>

<script>
import { getAttentionName } from '@/domain/ticket/ticket.model';
import GenericCard from '@/infrastructure/vue/components/common/cards/GenericCard';
import ValidateDocumentForm from '@/infrastructure/vue/components/common/forms/ValidateDocumentForm';
import NonCustomerRecordModal from '../../common/modals/NonCustomerRecordModal';
export default {
  name: 'ValidateDocument',
  components: {
    GenericCard,
    ValidateDocumentForm,
    NonCustomerRecordModal,
  },
  props: {
    attentionType: { type: Number, default: null },
  },
  computed: {
    subtitleForm() {
      return getAttentionName(this.attentionType);
    },
    requireLastName() {
      return this.documentType !== 3 ? 'required' : '';
    },
  },
  data: () => ({
    loading: false,
    loadingModal: false,
    documentType: null,
    document: '',
  }),
  methods: {
    async searchDocument({ documentType, document }) {
      this.loading = true;
      this.documentType = documentType;
      this.document = document;
      const event = await this.$store.dispatch(
        'ticket/validatePersonAction',
        document
      );
      if (event === 'NON_CLIENT_UNREGISTERED') {
        this.$refs.nonCustomerRecord.open();
      }
      this.loading = false;
    },
    async registerCustomer(payload) {
      this.loadingModal = true;
      await this.$store.dispatch('ticket/registerNonClientAction', {
        ...payload,
        documentType: this.documentType,
        document: this.document,
      });
      this.loadingModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.validate-document {
  &__container {
    width: 480px;
    margin: 0 auto;
  }
  &__card {
    padding: 40px;
  }
}
</style>
